import "./profile.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useAuth } from "../../context/AuthContext";
import { useData } from "../../context/DataContext";
import { Box, Typography, TextField, Button, Avatar, Snackbar, Alert } from "@mui/material";
import { useState } from "react";
import { userService } from "../../firebase/services";

const Profile = () => {
  const { user } = useAuth();
  const { updateUser } = useData();
  const [name, setName] = useState(user?.name || user?.fullName || "");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      // Use user.id or user.uid depending on your Firestore structure
      const userId = user?.id || user?.uid;
      if (!userId) throw new Error("User ID not found");
      const result = await userService.updateUser(userId, { name });
      if (result.success) {
        // Optionally update context
        if (updateUser) await updateUser(userId, { name });
        setSuccess(true);
      } else {
        setError(result.error?.message || "Failed to update profile");
      }
    } catch (err) {
      setError(err.message || "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile">
      <Sidebar />
      <div className="profileContainer">
        <Navbar />
        <div className="profileContent">
          <Typography variant="h4" sx={{ mb: 4 }}>Profile</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 600 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ width: 100, height: 100 }} />
              <Button variant="contained" component="label">
                Upload Photo
                <input hidden accept="image/*" type="file" />
              </Button>
            </Box>
            <TextField
              label="Name"
              value={name}
              onChange={e => setName(e.target.value)}
              fullWidth
            />
            <TextField
              label="Email"
              defaultValue={user?.email}
              fullWidth
              disabled
            />
            <TextField
              label="Role"
              defaultValue={user?.role}
              fullWidth
              disabled
            />
            <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </Button>
          </Box>
          <Snackbar open={!!success} autoHideDuration={2000} onClose={() => setSuccess(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
              Profile updated successfully!
            </Alert>
          </Snackbar>
          <Snackbar open={!!error} autoHideDuration={3000} onClose={() => setError("")} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={() => setError("")} severity="error" sx={{ width: '100%' }}>
              {error}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </div>
  );
};

export default Profile; 